import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { decryptData, defaulUrl } from "./const";
import Swal from "sweetalert2";

const useAutoLogout = (timeout = 5 * 60 * 1000) => {
    const navigate = useNavigate();

    const logout = () => {
        fetch(`${defaulUrl}logout`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                Accept: 'Application/json'
            }
        }).catch(console.error);

        localStorage.clear();
        Swal.fire({
            title: 'Session expirée.',
            text: 'Vous avez été déconnecté.',
            icon: 'warning',
            allowOutsideClick: true
        });
        navigate("/login");
    };

    useEffect(() => {
        let logoutTimer;

        const resetTimer = () => {
            clearTimeout(logoutTimer);
            logoutTimer = setTimeout(() => {
                logout();
            }, timeout);
        };

        // Liste des événements utilisateur
        const events = ["mousemove", "keydown", "touchstart", "visibilitychange", "focus", "touchmove"];
        events.forEach(event => {
            window.addEventListener(event, resetTimer)
        });
        resetTimer();

        return () => {
            clearTimeout(logoutTimer);
            events.forEach(event => window.removeEventListener(event, resetTimer));
            // window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [timeout, navigate]);
};


export default useAutoLogout;

